import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface AnalyticsDataStatusFooterProps {
  readonly status: 'ok' | 'warn' | 'error' | 'loading';
  readonly lastUpdatedLabel: string;
  readonly refreshIntervalLabel: string;
  readonly aboutDataHref?: string;
  readonly className?: string;
  /** Override footer region test id (TCC uses `tcc-footer-status`). */
  readonly testId?: string;
}

/**
 * Sticky analytics data-status footer (Plan §2.2).
 * Mid-page freshness `ok` state moves here; warn/error chip lives in header (Part 9).
 */
export const AnalyticsDataStatusFooter = memo<AnalyticsDataStatusFooterProps>(
  ({
    status,
    lastUpdatedLabel,
    refreshIntervalLabel,
    aboutDataHref,
    className = '',
    testId = 'analytics-data-status-footer',
  }) => {
    const { t } = useTranslation('admin');
    const classes = [
      'an-freshness-footer',
      `an-freshness-footer--${status}`,
      className,
    ]
      .filter((c) => c.length > 0)
      .join(' ');

    return (
      <footer
        className={classes}
        data-testid={testId}
        role="status"
      >
        <span>
          {[refreshIntervalLabel.trim(), lastUpdatedLabel.trim()]
            .filter((part) => part.length > 0)
            .join(' ')}
        </span>
        {aboutDataHref != null && aboutDataHref !== '' ? (
          <a href={aboutDataHref} className="admin-link">
            {t('analytics.freshness.aboutData')}
          </a>
        ) : null}
      </footer>
    );
  },
);

AnalyticsDataStatusFooter.displayName = 'AnalyticsDataStatusFooter';
